module.exports = __webpack_public_path__ + "media/images/participate-baby-logo-a4702b9bbf1b66c5c26f9cb720b55115.png";